export default angular
  .module('doxy.patient.common.services.updatePageMeta', [])
  .factory('updatePatientPageMeta', function ($rootScope, $translate) {
    return function ({ room, roomAdminCanUsePaidFeatures }) {
      // Safety check for room and its methods
      if (!room || !room.getDisplayName || typeof room.getDisplayName !== 'function') {
        console.warn('updatePatientPageMeta: room or getDisplayName method not available');
        return;
      }
      
      const displayName = room.getDisplayName();
      const subscriptionType = roomAdminCanUsePaidFeatures ? 'paid' : 'free';
      const roomUrl = window.location.href;

      $rootScope.$emit('updatePageMeta', {
        title: $translate.instant('patient.meta.title', { displayName }),
        description: $translate.instant('patient.meta.description', {
          displayName,
        }),
        metaTags: {
          'og:image': `${window.location.origin}/assets/images/og-image.jpg`,
          'twitter:card': 'summary_large_image',
          'og:url': roomUrl,
          'og:type': 'website',
          'og:description': $translate.instant(
            `account.dashboard.invite.og-description-${subscriptionType}`,
            { roomUrl }
          ),
          'og:title': $translate.instant(
            `account.dashboard.invite.og-title-${subscriptionType}`,
            {
              doctorName: displayName,
            }
          ),
          // Prevent Google from indexing provider pages
          robots: 'noindex',
        },
      });
    };
  }).name;
